import { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import useTransformGatsbyData from '../useTransformGatsbyData';

const GQL_FETCH_CATEGORIES_TINY = graphql`
  {
    allBwCategoryTiny {
      nodes {
        data
      }
    }
  }
`;

export default function useFetchAllCategories() {
  const data = useStaticQuery(GQL_FETCH_CATEGORIES_TINY);
  const allBwCategoryTiny = useTransformGatsbyData(data.allBwCategoryTiny);

  const allCategories = useMemo(
    () =>
      allBwCategoryTiny.reduce((acc, category) => {
        acc[category.categoryDbName] = category;
        return acc;
      }, {}),
    [allBwCategoryTiny]
  );

  return {
    allCategories,
  };
}
